/* * * * * * * * * * * * * * * * * * * * * * * * * * * * * *

Global solution for simple AJAX forms

Usage:

<div id="example-form-container">
    <form class="ajax-form" data-form-container-id="example-form-container" data-success-data-layer-event="newsletter.sent" action="/example-url/">
        <div
            data-layer-variable="example-variable-1"
            data-layer-value="example-value-1"
            >
        </div>
        ...
    </form>
</div>

Google Tag Manager GTM note:

Send a custom event to GTM by adding the 'data-success-data-layer-event' attribute to the <form> and pass a value e.g. 'newsletter.sent' that matched your GTM settings.

Important:

Obviously, the container ID ("example-form-container") has to be unique, not just to pass the HTML validator.

*/

export function allAuthSendAjaxForm($form) {

    // init
    var url = $form.attr('action');
    var custom_event = $form.attr('data-success-data-layer-event');
    var success_url = $form.attr('data-success-url');
    var $form_container = $form.parents('.tingle-modal-box__content');
    var postData = $form.serialize();

    // AJAX magic
    $.ajax({
        type: "POST",
        url : url,
        data : postData,
        success:function(data, textStatus, jqXHR) {

            // priority 1: WE define a success URL
            if (success_url) {
                window.location.href = success_url;
            }
            // priority 2: the success URL (location) from the view
            else if (data.location) {
                window.location.href = data.location;
            }
            // otherwise, write HTML
            else {
                $form_container.html(data.html);
            }

            // Google Tag Manager in use?
            if (typeof dataLayer !== 'undefined') {
                // Is there a custom event defined?
                if (custom_event) {
                    // add values to array
                    dataLayer.push({
                        'event': custom_event,
                    });
                }
            }

            // trigger custom events
            $(window).trigger('all-auth-form:success');
            $(window).trigger('initAjaxForm');
            $(window).trigger('initDatepicker');
            $(window).trigger('initFormModalClose');
            $(window).trigger('initFormValidation');
        },
        error: function(jqXHR, textStatus, errorThrown) {
            // if it fails and we have a response, write it in container
            if (jqXHR.responseJSON) {
                $form_container.html(jqXHR.responseJSON.html);
            }
            $(window).trigger('all-auth-form:error');
        }
    });

}

export function initAllAuthAjaxForm() {

    // find .ajax-form elements and loop!
    let ajax_forms = document.querySelectorAll('.allauth-ajax');
    if(ajax_forms.length > 0) {
        for (var i = 0; i < ajax_forms.length; i++) {
            // init
            var $form = $(ajax_forms[i]);
            // only listen for the submit event, if the form is not being validated
            if ($form.hasClass('validate-form') === false) {
                $form.on('submit', function(event){
                    allAuthSendAjaxForm($form);
                    event.preventDefault();
                });
            }
        }
    }

}

$(function(){

    // on page load
    initAllAuthAjaxForm();

    // custom event
    $(window).on('initAllAuthAjaxForm form-modal:opened all-auth-form:success all-auth-form:error', function() {
        initAllAuthAjaxForm();
    });

});



// WEBPACK FOOTER //
// ./static/js/modules/allauth-ajax.js